import athenaConfig from '../../../config';
import FactorsList from '../../../components/factor-list/FactorsList';
import BaseForgeCustomizer from '../../base-forge';
import { isAnetUser } from '../../../utils/user-utils';
import { enrolledFactorsDuringVerification } from '../../../utils/widget-facade';
import AmplitudeUtils from '../../../utils/amplitude-utils';
import { PHONE_FACTOR_ENROLLMENT_EVENT_NAME } from '../../../constants';

const { oieEnabled } = athenaConfig;
export default class ChallengeFactorOieCustomizer extends BaseForgeCustomizer {

  private isAnetUser: boolean = isAnetUser();
  displayFooterText = this.isAnetUser;


  async shouldCustomize() {
    return this.context.formName === 'select-authenticator-authenticate' && oieEnabled;
  }

  protected forgifyController() {
    const enrolledFactorList = enrolledFactorsDuringVerification();
    const moreThanOneSmsFactorEnrolled: boolean = enrolledFactorList.filter((factor: any) => factor?.relatesTo?.id?.startsWith('sms'))?.length > 1;
    const moreThanOneVoiceFactorEnrolled: boolean = enrolledFactorList.filter((factor: any) => factor?.relatesTo?.id?.startsWith('cl'))?.length > 1;

    if (!this.isAnetUser && (moreThanOneSmsFactorEnrolled || moreThanOneVoiceFactorEnrolled)) {
      AmplitudeUtils.logCustomEvent(PHONE_FACTOR_ENROLLMENT_EVENT_NAME, { workflow: 'MFAVerify' });
    }

    super.forgifyController();
    this.forgifyFactors();
  }

  headerDescription = jQueryCourage('.o-form-explain').text();

  forgifyFactors() {
    const factors = jQueryCourage('.authenticator-verify-list');
    const forgeComponent = <FactorsList challenge oktaFactorsList={factors.find('.authenticator-row')}/>;
    this.renderForgeAndHideOktaComponent({ id: 'authenticator-verify-list', oktaComponent: factors, forgeComponent });
  }
}
